import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ThreeDots } from "react-loader-spinner";

// images
import LOGO_MTN2 from "./../../assets/images/mtn-logo.svg";
import { resetAbonnePassword } from "../../services/abonne/AbonneRequest";

const ResetPassword = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [isUpdated, setIsUpdated] = useState(false);
  const [codeOTP, setCodeOTP] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [errorMessagePassword, setErrorMessagePassword] = useState("");

  const modifierMotDePasse = () => {
    setLoading(true);
    setErrorMessagePassword("");
    const customerNumber = sessionStorage.getItem("customer_number")
      ? sessionStorage.getItem("customer_number")
      : "";

    if (newPassword === confirmPassword) {
      const updatePassword = {
        newPassword: newPassword,
        code: codeOTP,
        password: newPassword,
        passwordConfirm: confirmPassword,
        numero: customerNumber
      };

      resetAbonnePassword(updatePassword)
        .then((res) => {
          setLoading(false);
          setIsUpdated(true)
          resetAll();
          sessionStorage.setItem('token', res.data.accessToken)
        })
        .catch((err) => {
          setLoading(false);
          console.log(err);
          if (err.response) {
            setErrorMessagePassword(err.response.data.donnee);
          } else {
            setErrorMessagePassword(
              "Une erreur s'est produite, essayer plus tard"
            );
          }
        });
    } else {
      setLoading(false);
      setErrorMessagePassword("Les mots de passe ne sont pas identique");
    }
  };

  const resetAll = () => {
    setCodeOTP("");
    setPhoneNumber("");
    setNewPassword("");
    setConfirmPassword("");
    setErrorMessagePassword("");
    sessionStorage.removeItem("id");
  };

  const navigateToForfaitPage = () => {
    navigate("/forfaits/acheter");
  };

  useEffect(() => {
    if (sessionStorage.getItem("id")) {
      setCodeOTP(sessionStorage.getItem("id"));
    } else {
      navigate("/forget-password");
    }
  }, []);

  return (
    <div className="w-full min-h-screen bg-gray-mtn flex flex-col items-center pt-32">
      <div className="mb-10">
        <img src={LOGO_MTN2} alt="" className="w-32" />
      </div>
      <div className="pb-32">
        {!isUpdated ? <div className="w-[93vw] sm:w-[450px] max-w-[450px] h-fit bg-white shadow-xl rounded-xl border mx-3 p-5">
          <h1 className="text-center text-lg font-bold mx-5">
            Definir un nouveau mot de passe
          </h1>
          <div className="mt-8">
            <div className="mb-2">
              <label htmlFor="" className="text-sm">
                Mot de passe
              </label>
            </div>
            <input
              disabled={loading}
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              type="password"
              placeholder="******"
              className="input input-bordered w-full bg-gray-mtn"
            />
            <div className="my-2">
              <label htmlFor="" className="text-sm">
                Confirmer mot de passe
              </label>
            </div>
            <input
              disabled={loading}
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              type="password"
              placeholder="******"
              className="input input-bordered w-full bg-gray-mtn"
            />
          </div>
          <button
            disabled={loading}
            className="bg-jaune-mtn font-bold text-sm w-full h-10 rounded-lg mt-5 flex items-center justify-center"
            onClick={modifierMotDePasse}
          >
            {!loading ? (
              <>Modifier</>
            ) : (
              <ThreeDots
                height="40"
                width="40"
                radius="9"
                color="#000"
                ariaLabel="three-dots-loading"
                wrapperStyle={{}}
                wrapperClassName=""
                visible={loading}
              />
            )}
          </button>
          {errorMessagePassword ? (
            <div className="mt-4">
              <p className="text-red-500 text-center font-bold">
                {errorMessagePassword}
              </p>
            </div>
          ) : null}
          <div className="text-center mt-5">
            <Link to="/password-access">
              <button className="underline">Accéder à la connexion</button>
            </Link>
          </div>
        </div> : null}
        {isUpdated ? <div className="w-[93vw] sm:w-[450px] max-w-[450px] h-fit bg-white shadow-xl rounded-xl border mx-3 p-5">
          <h1 className="text-xl text-center text-green-500 font-bold mx-5">Succès</h1>
          <p className="text-center mt-3">Mot de passe modifié avec succès, continuer sur le portail.</p>
          <button className="bg-jaune-mtn w-full h-11 rounded-lg mt-5 font-bold" onClick={navigateToForfaitPage}>Continuer</button>
        </div> : null}
      </div>
    </div>
  );
};

export default ResetPassword;
